import { buildMailtoLink } from '../utils/mailto.js';
import { engagementsApi } from '../api/engagements.js';
import { useSender } from './useSender.js';

/**
 * One-click "send this template now" action for a specific engagement —
 * logs the communication (best-effort) and opens the mail client. Used by
 * inline "Email" shortcuts next to a status that needs action (e.g.
 * Agreement: Not sent, or an incomplete checklist item), not just the
 * Comms tab's own "Generate email draft" modal.
 */
export function useQuickEmail(engagement, event, speaker) {
  const sender = useSender();
  return async function sendQuickEmail(templateKey) {
    const mailto = buildMailtoLink(templateKey, engagement, event, speaker, sender);
    try {
      await engagementsApi.logCommunication(engagement.id, {
        commType: templateKey,
        recipient: speaker?.email ?? '',
        date: new Date().toISOString().slice(0, 10),
      });
    } catch { /* non-blocking */ }
    window.location.href = mailto;
  };
}
